import {decorate, inject, injectable} from '@yosmanyga/di';
import {action, observable, runInAction, makeObservable} from 'mobx';
import {LogType, RestorationApi} from '../../data';
import {Dispatcher} from '@yosmanyga/base';

class RestorationPromptController {
    restoring: boolean;
    selected: LogType | undefined;

    constructor(
        private dispatcher: Dispatcher,
        private restorationApi: RestorationApi
    ) {
        this.restoring = false;
        this.selected = undefined;

        this.dispatcher.register(
            'restoration_list_item_selected',
            this.listenToRestorationListItemSelected
        );

        makeObservable(this, {
            restoring: observable,
            selected: observable,
            restore: action,
            cancel: action
        });
    }

    restore = async () => {
        if (!this.selected) {
            throw new Error('LogicException');
        }

        runInAction(() => {
            this.restoring = true;
        });

        await this.restorationApi.restore(this.selected);

        runInAction(() => {
            this.restoring = false;
        });
    };

    cancel = () => {
        this.selected = undefined;
    };

    listenToRestorationListItemSelected = (value: LogType) => {
        this.selected = value;
    };
}

decorate(injectable(), RestorationPromptController);
decorate(inject(Dispatcher), RestorationPromptController, 0);
decorate(inject(RestorationApi), RestorationPromptController, 1);

export {RestorationPromptController};
